const global = window

// Remplissage automatique
inputs.behavior.sortable = function (data, name, niceName, type, input, parent, inputWindow) {
    const apiForm = input.closest('[data-api]')

    if (data.sortable) {
        const container = input.find('> tbody');
        const handle = '[data-name="' + data.sortable + '"]';
        const items = 'tr';

        container.sortable({
            items,
            handle,
            delay: 150,
            helper: 'clone',
            tolerance: 'intersect',
            appendTo: container,
            distance: 5,
            revert: 0,
            scrollSpeed: 8,
            scrollSensitivity: 20,
            scroll: true,
            cursorAt: { left: 58, top: -10 },
            create(event, ui) {
            },
            update(event, ui) {
                let data = {};
                $(this).find(items).each(function(i) {
                    data[$(this).data('value')] = i;
                })
                data = {
                    "data": data
                }
                if (apiForm) {
                    const url = apiForm.data('api') + '/order'
                    callAPI('PUT', url, data);
                } else if (data.sortUrl || data.sortAction) {
                    ajaxCall({
                        url: data.sortUrl || data.sortAction,
                        data: data
                    });
                }
            },
            start(event, ui) {
                /*
                if (!$(this).hasClass('iv__item--selected') && grid.find('.iv__item--selected').length) grid.find('.iv__item--selected').removeClass('iv__item--selected');
                ui.placeholder.addClass('iv__placeholder');
                ui.placeholder.height(ui.item.height());
                ui.placeholder.width(ui.item.width());
                */
            },
            stop(event, ui) {
                // $(this).height('auto')
            },
        });
    }
    return data
}
